import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Headers, RequestOptions, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { NotificationService } from "./notification.service";

declare var $: any;


@Injectable()
export class BodyService {

    public $body: any;


    constructor(private router: Router,
        protected notificationService: NotificationService) {
        this.$body = $('body');
    }


    addClass(className: string) {
        this.$body.addClass(className)
    }

    removeClass(className: string) {
        this.$body.removeClass(className)
    }

    toggleClass(className: string, state?: boolean) {
        this.$body.toggleClass(className, state)
    }

    jwt() {
        // create authorization header with jwt token
        
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('authorization', currentUser.token);
            //let headers = new Headers({ 'Authorization': + currentUser.token });
            return new RequestOptions({ headers: headers });
        }
    }

    jwtUploadFile() {
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers();
            headers.append('authorization', currentUser.token);
            return new RequestOptions({ headers: headers });
        }
    }

    jwtPDF() {
        // create authorization header with jwt token
        
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers();
            headers.append('Content-Type', 'application/pdf');
            headers.append('authorization', currentUser.token);
            //let headers = new Headers({ 'Authorization': + currentUser.token });
            return new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
        }
    }    

    // sample method from angular doc
    handleError(error: any) {
        
        if (error.status === 401) {
            window.location.href = '/';
        }

        let errMsg = "";
        if (error.status === 405) {
            errMsg = "Usuario no tiene PERMISOS para la ejecución de dicho Método";
            return Observable.throw(errMsg);
        }

        let token = sessionStorage.getItem('token');
        if (error.url == null) {
            if (token != null && (error.status == 0) && (error.statusText == "")) {
                sessionStorage.setItem('expiracion', 'S');
                return Observable.throw(errMsg);
            }
        }

        if (error.url == null && (token == null || token == '')) {
            errMsg = "No se pudo establecer comunicación con el Servidor";
            return Observable.throw(errMsg);
        }


        let errMsgJson = JSON.parse(error._body);
        if (errMsgJson.message === "/login.jsp") {
            errMsg = "Usuario / Password Incorrecto!!"
        }
        else {
            errMsg = "<br/><em>Excepcion: " + errMsgJson.exception +
                "</em><br/><strong>Mensaje: " + errMsgJson.message +
                "</strong><br/><br/>Status " + errMsgJson.status + "  Path: " + errMsgJson.path;
        }
        return Observable.throw(errMsg);


    }


    showPopupSessionExpirada() {
        this.notificationService.smartMessageBox({
            title: "<h1><i class='fa fa-sign-out txt-color-orangeDark'></i>&nbsp;Cerrar Sesión</h1> <span class='txt-color-orangeDark'><strong>" + $('#show-shortcut').text() + "</strong></span>",
            content: 'Sesión Expirada',
            buttons: '[Aceptar]'

        }, (ButtonPressed) => {
            if (ButtonPressed == "Aceptar") {
                this.logout();
                this.router.navigate(['/auth/login']);
                window.location.reload();
            }
        });
    }

    logout() {
        localStorage.removeItem('rutaServidor');
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('expiracion');
        localStorage.clear();
        sessionStorage.clear();

    }


}



// WEBPACK FOOTER //
// ./src/app/shared/utils/body.service.ts